export enum TrackChangeStatusLabels {
    PENDING = 'Pending approval',
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
    OPTIONGROUP = 'Option Group',
}
